export default __webpack_public_path__ + "static/media/clock-white.0c204b05.svg";